/* eslint-disable react/prop-types */
import styles from './styles.module.css'

export const TabSwitcher = ({ tabs = [], activeTab, onChange }) => {
  if (!tabs.length) return null

  return (
    <div className={styles.tabSwitcher} role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          className={`${styles.tab} ${activeTab === tab.id ? styles.tabActive : ''}`}
          onClick={() => onChange?.(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export default TabSwitcher
